"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.tooltip.view': 'View onboarding details',
    'onboarding.tooltip.edit': 'Edit onboarding entry',
    'onboarding.tooltip.delete': 'Delete onboarding entry',
};
